module.exports = __webpack_public_path__ + "img/logocort.9288dcb9.png";